import { createFormHook, createFormHookContexts } from '@tanstack/react-form';
import { TextField } from './TextField';
import { SubmitButton } from './SubmitButton';
import { SelectField } from './SelectField';
import { AutocompleteField } from './AutocompleteField';
import { LanguageField } from './LanguageField';
import { RadioGroupField } from './RadioGroupField';
import { CheckboxField } from './CheckboxField';
import { FileField } from './FileField';
import { NumberField } from './NumberField';
import { TipTapField } from './TipTapField';
import { DateField } from './DateField';
import { DateTimeField } from './DateTimeField';
import { TimeField } from './TimeField';

export const { fieldContext, useFieldContext, formContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm } = createFormHook({
  fieldComponents: {
    TextField,
    SelectField,
    AutocompleteField,
    LanguageField,
    RadioGroupField,
    CheckboxField,
    FileField,
    NumberField,
    TipTapField,
    DateField,
    DateTimeField,
    TimeField,
  },
  formComponents: {
    SubmitButton,
  },
  fieldContext,
  formContext,
});
